package flagpack.icons

import androidx.compose.ui.graphics.vector.ImageVector
import flagpack.icons.medium.Afghanistan
import flagpack.icons.medium.AlandIslands
import flagpack.icons.medium.Albania
import flagpack.icons.medium.Algeria
import flagpack.icons.medium.AmericanSamoa
import flagpack.icons.medium.Andorra
import flagpack.icons.medium.Angola
import flagpack.icons.medium.Anguilla
import flagpack.icons.medium.Antarctica
import flagpack.icons.medium.AntiguaAndBarbuda
import flagpack.icons.medium.Argentina
import flagpack.icons.medium.Armenia
import flagpack.icons.medium.Aruba
import flagpack.icons.medium.Australia
import flagpack.icons.medium.Austria
import flagpack.icons.medium.Azerbaijan
import flagpack.icons.medium.Bahamas
import flagpack.icons.medium.Bahrain
import flagpack.icons.medium.Bangladesh
import flagpack.icons.medium.Barbados
import flagpack.icons.medium.Belarus
import flagpack.icons.medium.Belgium
import flagpack.icons.medium.Belize
import flagpack.icons.medium.Benin
import flagpack.icons.medium.Bermuda
import flagpack.icons.medium.Bhutan
import flagpack.icons.medium.Bolivia
import flagpack.icons.medium.Bonaire
import flagpack.icons.medium.BosniaAndHerzegovina
import flagpack.icons.medium.Botswana
import flagpack.icons.medium.BouvetIsland
import flagpack.icons.medium.Brazil
import flagpack.icons.medium.BritishIndianOceanTerritory
import flagpack.icons.medium.BritishVirginIslands
import flagpack.icons.medium.Brunei
import flagpack.icons.medium.Bulgaria
import flagpack.icons.medium.BurkinaFaso
import flagpack.icons.medium.Burundi
import flagpack.icons.medium.Cambodia
import flagpack.icons.medium.Cameroon
import flagpack.icons.medium.Canada
import flagpack.icons.medium.CapeVerde
import flagpack.icons.medium.CaymanIslands
import flagpack.icons.medium.CentralAfricanRepublic
import flagpack.icons.medium.Chad
import flagpack.icons.medium.Chile
import flagpack.icons.medium.China
import flagpack.icons.medium.ChristmasIsland
import flagpack.icons.medium.CocosIslands
import flagpack.icons.medium.Colombia
import flagpack.icons.medium.Comoros
import flagpack.icons.medium.Congo
import flagpack.icons.medium.CookIslands
import flagpack.icons.medium.CostaRica
import flagpack.icons.medium.CoteDivoire
import flagpack.icons.medium.Croatia
import flagpack.icons.medium.Cuba
import flagpack.icons.medium.Curacao
import flagpack.icons.medium.Cyprus
import flagpack.icons.medium.CzechRepublic
import flagpack.icons.medium.DemocraticRepublicOfCongo
import flagpack.icons.medium.Denmark
import flagpack.icons.medium.Djibouti
import flagpack.icons.medium.Dominica
import flagpack.icons.medium.DominicanRepublic
import flagpack.icons.medium.Ecuador
import flagpack.icons.medium.Egypt
import flagpack.icons.medium.ElSalvador
import flagpack.icons.medium.England
import flagpack.icons.medium.EquatorialGuinea
import flagpack.icons.medium.Eritrea
import flagpack.icons.medium.Estonia
import flagpack.icons.medium.Eswatini
import flagpack.icons.medium.Ethiopia
import flagpack.icons.medium.FalklandIslands
import flagpack.icons.medium.FaroeIslands
import flagpack.icons.medium.Fiji
import flagpack.icons.medium.Finland
import flagpack.icons.medium.France
import flagpack.icons.medium.FrenchGuiana
import flagpack.icons.medium.FrenchPolynesia
import flagpack.icons.medium.FrenchSouthernTerritories
import flagpack.icons.medium.Gabon
import flagpack.icons.medium.Gambia
import flagpack.icons.medium.Georgia
import flagpack.icons.medium.Germany
import flagpack.icons.medium.Ghana
import flagpack.icons.medium.Gibraltar
import flagpack.icons.medium.Greece
import flagpack.icons.medium.Greenland
import flagpack.icons.medium.Grenada
import flagpack.icons.medium.Guadeloupe
import flagpack.icons.medium.Guam
import flagpack.icons.medium.Guatemala
import flagpack.icons.medium.Guernsey
import flagpack.icons.medium.Guinea
import flagpack.icons.medium.GuineaBissau
import flagpack.icons.medium.Guyana
import flagpack.icons.medium.Haiti
import flagpack.icons.medium.HeardIslandAndMcdonaldIslands
import flagpack.icons.medium.Honduras
import flagpack.icons.medium.HongKong
import flagpack.icons.medium.Hungary
import flagpack.icons.medium.Iceland
import flagpack.icons.medium.India
import flagpack.icons.medium.Indonesia
import flagpack.icons.medium.Iran
import flagpack.icons.medium.Iraq
import flagpack.icons.medium.Ireland
import flagpack.icons.medium.IsleOfMan
import flagpack.icons.medium.Israel
import flagpack.icons.medium.Italy
import flagpack.icons.medium.Jamaica
import flagpack.icons.medium.Japan
import flagpack.icons.medium.Jersey
import flagpack.icons.medium.Jordan
import flagpack.icons.medium.Kazakhstan
import flagpack.icons.medium.Kenya
import flagpack.icons.medium.Kiribati
import flagpack.icons.medium.Kuwait
import flagpack.icons.medium.Kyrgyzstan
import flagpack.icons.medium.Laos
import flagpack.icons.medium.Latvia
import flagpack.icons.medium.Lebanon
import flagpack.icons.medium.Lesotho
import flagpack.icons.medium.Liberia
import flagpack.icons.medium.Libya
import flagpack.icons.medium.Liechtenstein
import flagpack.icons.medium.Lithuania
import flagpack.icons.medium.Luxembourg
import flagpack.icons.medium.Macao
import flagpack.icons.medium.Madagascar
import flagpack.icons.medium.Malawi
import flagpack.icons.medium.Malaysia
import flagpack.icons.medium.Maldives
import flagpack.icons.medium.Mali
import flagpack.icons.medium.Malta
import flagpack.icons.medium.MarshallIslands
import flagpack.icons.medium.Martinique
import flagpack.icons.medium.Mauritania
import flagpack.icons.medium.Mauritius
import flagpack.icons.medium.Mayotte
import flagpack.icons.medium.Mexico
import flagpack.icons.medium.Micronesia
import flagpack.icons.medium.Moldova
import flagpack.icons.medium.Monaco
import flagpack.icons.medium.Mongolia
import flagpack.icons.medium.Montenegro
import flagpack.icons.medium.Montserrat
import flagpack.icons.medium.Morocco
import flagpack.icons.medium.Mozambique
import flagpack.icons.medium.Myanmar
import flagpack.icons.medium.Namibia
import flagpack.icons.medium.Nauru
import flagpack.icons.medium.Nepal
import flagpack.icons.medium.Netherlands
import flagpack.icons.medium.NewCaledonia
import flagpack.icons.medium.NewZealand
import flagpack.icons.medium.Nicaragua
import flagpack.icons.medium.Niger
import flagpack.icons.medium.Nigeria
import flagpack.icons.medium.Niue
import flagpack.icons.medium.NorfolkIsland
import flagpack.icons.medium.NorthKorea
import flagpack.icons.medium.NorthMacedonia
import flagpack.icons.medium.NorthernIreland
import flagpack.icons.medium.NorthernMarianaIslands
import flagpack.icons.medium.Norway
import flagpack.icons.medium.Oman
import flagpack.icons.medium.Pakistan
import flagpack.icons.medium.Palau
import flagpack.icons.medium.Palestine
import flagpack.icons.medium.Panama
import flagpack.icons.medium.PapuaNewGuinea
import flagpack.icons.medium.Paraguay
import flagpack.icons.medium.Peru
import flagpack.icons.medium.Philippines
import flagpack.icons.medium.PitcairnIslands
import flagpack.icons.medium.Poland
import flagpack.icons.medium.Portugal
import flagpack.icons.medium.PuertoRico
import flagpack.icons.medium.Qatar
import flagpack.icons.medium.Reunion
import flagpack.icons.medium.Romania
import flagpack.icons.medium.Russia
import flagpack.icons.medium.Rwanda
import flagpack.icons.medium.Saba
import flagpack.icons.medium.SaintBarthelemy
import flagpack.icons.medium.SaintHelena
import flagpack.icons.medium.SaintKittsAndNevis
import flagpack.icons.medium.SaintLucia
import flagpack.icons.medium.SaintMartin
import flagpack.icons.medium.SaintPierreAndMiquelon
import flagpack.icons.medium.SaintVincentAndTheGrenadines
import flagpack.icons.medium.Samoa
import flagpack.icons.medium.SanMarino
import flagpack.icons.medium.SaoTomeAndPrincipe
import flagpack.icons.medium.SaudiArabia
import flagpack.icons.medium.Scotland
import flagpack.icons.medium.Senegal
import flagpack.icons.medium.Serbia
import flagpack.icons.medium.Seychelles
import flagpack.icons.medium.SierraLeone
import flagpack.icons.medium.Singapore
import flagpack.icons.medium.SintEustatius
import flagpack.icons.medium.SintMaarten
import flagpack.icons.medium.Slovakia
import flagpack.icons.medium.Slovenia
import flagpack.icons.medium.SolomonIslands
import flagpack.icons.medium.Somalia
import flagpack.icons.medium.SouthAfrica
import flagpack.icons.medium.SouthGeorgia
import flagpack.icons.medium.SouthKorea
import flagpack.icons.medium.SouthSudan
import flagpack.icons.medium.Spain
import flagpack.icons.medium.SriLanka
import flagpack.icons.medium.Sudan
import flagpack.icons.medium.Suriname
import flagpack.icons.medium.SvalbardAndJanMayen
import flagpack.icons.medium.Sweden
import flagpack.icons.medium.Switzerland
import flagpack.icons.medium.Syria
import flagpack.icons.medium.Taiwan
import flagpack.icons.medium.Tajikistan
import flagpack.icons.medium.Tanzania
import flagpack.icons.medium.Thailand
import flagpack.icons.medium.TimorLeste
import flagpack.icons.medium.Togo
import flagpack.icons.medium.Tokelau
import flagpack.icons.medium.Tonga
import flagpack.icons.medium.TrinidadAndTobago
import flagpack.icons.medium.Tunisia
import flagpack.icons.medium.Turkey
import flagpack.icons.medium.Turkmenistan
import flagpack.icons.medium.TurksAndCaicosIslands
import flagpack.icons.medium.Tuvalu
import flagpack.icons.medium.Uganda
import flagpack.icons.medium.Ukraine
import flagpack.icons.medium.UnitedArabEmirates
import flagpack.icons.medium.UnitedKingdom
import flagpack.icons.medium.UnitedStates
import flagpack.icons.medium.Uruguay
import flagpack.icons.medium.UsMinorOutlyingIslands
import flagpack.icons.medium.UsVirginIslands
import flagpack.icons.medium.Uzbekistan
import flagpack.icons.medium.Vanuatu
import flagpack.icons.medium.VaticanCity
import flagpack.icons.medium.Venezuela
import flagpack.icons.medium.Vietnam
import flagpack.icons.medium.Wales
import flagpack.icons.medium.WallisAndFutuna
import flagpack.icons.medium.WesternSahara
import flagpack.icons.medium.Yemen
import flagpack.icons.medium.Zambia
import flagpack.icons.medium.Zimbabwe

/**
 * List of all Medium (20x15dp) flag icons.
 *
 * Contains 255 flags, lazily initialized.
 */
public val FlagIcons.MediumFlagList: List<ImageVector>
    get() {
        if (_mediumFlagList != null) {
            return _mediumFlagList!!
        }
        _mediumFlagList = listOf(
            FlagIcons.Medium.Afghanistan,
            FlagIcons.Medium.AlandIslands,
            FlagIcons.Medium.Albania,
            FlagIcons.Medium.Algeria,
            FlagIcons.Medium.AmericanSamoa,
            FlagIcons.Medium.Andorra,
            FlagIcons.Medium.Angola,
            FlagIcons.Medium.Anguilla,
            FlagIcons.Medium.Antarctica,
            FlagIcons.Medium.AntiguaAndBarbuda,
            FlagIcons.Medium.Argentina,
            FlagIcons.Medium.Armenia,
            FlagIcons.Medium.Aruba,
            FlagIcons.Medium.Australia,
            FlagIcons.Medium.Austria,
            FlagIcons.Medium.Azerbaijan,
            FlagIcons.Medium.Bahamas,
            FlagIcons.Medium.Bahrain,
            FlagIcons.Medium.Bangladesh,
            FlagIcons.Medium.Barbados,
            FlagIcons.Medium.Belarus,
            FlagIcons.Medium.Belgium,
            FlagIcons.Medium.Belize,
            FlagIcons.Medium.Benin,
            FlagIcons.Medium.Bermuda,
            FlagIcons.Medium.Bhutan,
            FlagIcons.Medium.Bolivia,
            FlagIcons.Medium.Bonaire,
            FlagIcons.Medium.BosniaAndHerzegovina,
            FlagIcons.Medium.Botswana,
            FlagIcons.Medium.BouvetIsland,
            FlagIcons.Medium.Brazil,
            FlagIcons.Medium.BritishIndianOceanTerritory,
            FlagIcons.Medium.BritishVirginIslands,
            FlagIcons.Medium.Brunei,
            FlagIcons.Medium.Bulgaria,
            FlagIcons.Medium.BurkinaFaso,
            FlagIcons.Medium.Burundi,
            FlagIcons.Medium.Cambodia,
            FlagIcons.Medium.Cameroon,
            FlagIcons.Medium.Canada,
            FlagIcons.Medium.CapeVerde,
            FlagIcons.Medium.CaymanIslands,
            FlagIcons.Medium.CentralAfricanRepublic,
            FlagIcons.Medium.Chad,
            FlagIcons.Medium.Chile,
            FlagIcons.Medium.China,
            FlagIcons.Medium.ChristmasIsland,
            FlagIcons.Medium.CocosIslands,
            FlagIcons.Medium.Colombia,
            FlagIcons.Medium.Comoros,
            FlagIcons.Medium.Congo,
            FlagIcons.Medium.CookIslands,
            FlagIcons.Medium.CostaRica,
            FlagIcons.Medium.CoteDivoire,
            FlagIcons.Medium.Croatia,
            FlagIcons.Medium.Cuba,
            FlagIcons.Medium.Curacao,
            FlagIcons.Medium.Cyprus,
            FlagIcons.Medium.CzechRepublic,
            FlagIcons.Medium.DemocraticRepublicOfCongo,
            FlagIcons.Medium.Denmark,
            FlagIcons.Medium.Djibouti,
            FlagIcons.Medium.Dominica,
            FlagIcons.Medium.DominicanRepublic,
            FlagIcons.Medium.Ecuador,
            FlagIcons.Medium.Egypt,
            FlagIcons.Medium.ElSalvador,
            FlagIcons.Medium.England,
            FlagIcons.Medium.EquatorialGuinea,
            FlagIcons.Medium.Eritrea,
            FlagIcons.Medium.Estonia,
            FlagIcons.Medium.Eswatini,
            FlagIcons.Medium.Ethiopia,
            FlagIcons.Medium.FalklandIslands,
            FlagIcons.Medium.FaroeIslands,
            FlagIcons.Medium.Fiji,
            FlagIcons.Medium.Finland,
            FlagIcons.Medium.France,
            FlagIcons.Medium.FrenchGuiana,
            FlagIcons.Medium.FrenchPolynesia,
            FlagIcons.Medium.FrenchSouthernTerritories,
            FlagIcons.Medium.Gabon,
            FlagIcons.Medium.Gambia,
            FlagIcons.Medium.Georgia,
            FlagIcons.Medium.Germany,
            FlagIcons.Medium.Ghana,
            FlagIcons.Medium.Gibraltar,
            FlagIcons.Medium.Greece,
            FlagIcons.Medium.Greenland,
            FlagIcons.Medium.Grenada,
            FlagIcons.Medium.Guadeloupe,
            FlagIcons.Medium.Guam,
            FlagIcons.Medium.Guatemala,
            FlagIcons.Medium.Guernsey,
            FlagIcons.Medium.Guinea,
            FlagIcons.Medium.GuineaBissau,
            FlagIcons.Medium.Guyana,
            FlagIcons.Medium.Haiti,
            FlagIcons.Medium.HeardIslandAndMcdonaldIslands,
            FlagIcons.Medium.Honduras,
            FlagIcons.Medium.HongKong,
            FlagIcons.Medium.Hungary,
            FlagIcons.Medium.Iceland,
            FlagIcons.Medium.India,
            FlagIcons.Medium.Indonesia,
            FlagIcons.Medium.Iran,
            FlagIcons.Medium.Iraq,
            FlagIcons.Medium.Ireland,
            FlagIcons.Medium.IsleOfMan,
            FlagIcons.Medium.Israel,
            FlagIcons.Medium.Italy,
            FlagIcons.Medium.Jamaica,
            FlagIcons.Medium.Japan,
            FlagIcons.Medium.Jersey,
            FlagIcons.Medium.Jordan,
            FlagIcons.Medium.Kazakhstan,
            FlagIcons.Medium.Kenya,
            FlagIcons.Medium.Kiribati,
            FlagIcons.Medium.Kuwait,
            FlagIcons.Medium.Kyrgyzstan,
            FlagIcons.Medium.Laos,
            FlagIcons.Medium.Latvia,
            FlagIcons.Medium.Lebanon,
            FlagIcons.Medium.Lesotho,
            FlagIcons.Medium.Liberia,
            FlagIcons.Medium.Libya,
            FlagIcons.Medium.Liechtenstein,
            FlagIcons.Medium.Lithuania,
            FlagIcons.Medium.Luxembourg,
            FlagIcons.Medium.Macao,
            FlagIcons.Medium.Madagascar,
            FlagIcons.Medium.Malawi,
            FlagIcons.Medium.Malaysia,
            FlagIcons.Medium.Maldives,
            FlagIcons.Medium.Mali,
            FlagIcons.Medium.Malta,
            FlagIcons.Medium.MarshallIslands,
            FlagIcons.Medium.Martinique,
            FlagIcons.Medium.Mauritania,
            FlagIcons.Medium.Mauritius,
            FlagIcons.Medium.Mayotte,
            FlagIcons.Medium.Mexico,
            FlagIcons.Medium.Micronesia,
            FlagIcons.Medium.Moldova,
            FlagIcons.Medium.Monaco,
            FlagIcons.Medium.Mongolia,
            FlagIcons.Medium.Montenegro,
            FlagIcons.Medium.Montserrat,
            FlagIcons.Medium.Morocco,
            FlagIcons.Medium.Mozambique,
            FlagIcons.Medium.Myanmar,
            FlagIcons.Medium.Namibia,
            FlagIcons.Medium.Nauru,
            FlagIcons.Medium.Nepal,
            FlagIcons.Medium.Netherlands,
            FlagIcons.Medium.NewCaledonia,
            FlagIcons.Medium.NewZealand,
            FlagIcons.Medium.Nicaragua,
            FlagIcons.Medium.Niger,
            FlagIcons.Medium.Nigeria,
            FlagIcons.Medium.Niue,
            FlagIcons.Medium.NorfolkIsland,
            FlagIcons.Medium.NorthKorea,
            FlagIcons.Medium.NorthMacedonia,
            FlagIcons.Medium.NorthernIreland,
            FlagIcons.Medium.NorthernMarianaIslands,
            FlagIcons.Medium.Norway,
            FlagIcons.Medium.Oman,
            FlagIcons.Medium.Pakistan,
            FlagIcons.Medium.Palau,
            FlagIcons.Medium.Palestine,
            FlagIcons.Medium.Panama,
            FlagIcons.Medium.PapuaNewGuinea,
            FlagIcons.Medium.Paraguay,
            FlagIcons.Medium.Peru,
            FlagIcons.Medium.Philippines,
            FlagIcons.Medium.PitcairnIslands,
            FlagIcons.Medium.Poland,
            FlagIcons.Medium.Portugal,
            FlagIcons.Medium.PuertoRico,
            FlagIcons.Medium.Qatar,
            FlagIcons.Medium.Reunion,
            FlagIcons.Medium.Romania,
            FlagIcons.Medium.Russia,
            FlagIcons.Medium.Rwanda,
            FlagIcons.Medium.Saba,
            FlagIcons.Medium.SaintBarthelemy,
            FlagIcons.Medium.SaintHelena,
            FlagIcons.Medium.SaintKittsAndNevis,
            FlagIcons.Medium.SaintLucia,
            FlagIcons.Medium.SaintMartin,
            FlagIcons.Medium.SaintPierreAndMiquelon,
            FlagIcons.Medium.SaintVincentAndTheGrenadines,
            FlagIcons.Medium.Samoa,
            FlagIcons.Medium.SanMarino,
            FlagIcons.Medium.SaoTomeAndPrincipe,
            FlagIcons.Medium.SaudiArabia,
            FlagIcons.Medium.Scotland,
            FlagIcons.Medium.Senegal,
            FlagIcons.Medium.Serbia,
            FlagIcons.Medium.Seychelles,
            FlagIcons.Medium.SierraLeone,
            FlagIcons.Medium.Singapore,
            FlagIcons.Medium.SintEustatius,
            FlagIcons.Medium.SintMaarten,
            FlagIcons.Medium.Slovakia,
            FlagIcons.Medium.Slovenia,
            FlagIcons.Medium.SolomonIslands,
            FlagIcons.Medium.Somalia,
            FlagIcons.Medium.SouthAfrica,
            FlagIcons.Medium.SouthGeorgia,
            FlagIcons.Medium.SouthKorea,
            FlagIcons.Medium.SouthSudan,
            FlagIcons.Medium.Spain,
            FlagIcons.Medium.SriLanka,
            FlagIcons.Medium.Sudan,
            FlagIcons.Medium.Suriname,
            FlagIcons.Medium.SvalbardAndJanMayen,
            FlagIcons.Medium.Sweden,
            FlagIcons.Medium.Switzerland,
            FlagIcons.Medium.Syria,
            FlagIcons.Medium.Taiwan,
            FlagIcons.Medium.Tajikistan,
            FlagIcons.Medium.Tanzania,
            FlagIcons.Medium.Thailand,
            FlagIcons.Medium.TimorLeste,
            FlagIcons.Medium.Togo,
            FlagIcons.Medium.Tokelau,
            FlagIcons.Medium.Tonga,
            FlagIcons.Medium.TrinidadAndTobago,
            FlagIcons.Medium.Tunisia,
            FlagIcons.Medium.Turkey,
            FlagIcons.Medium.Turkmenistan,
            FlagIcons.Medium.TurksAndCaicosIslands,
            FlagIcons.Medium.Tuvalu,
            FlagIcons.Medium.Uganda,
            FlagIcons.Medium.Ukraine,
            FlagIcons.Medium.UnitedArabEmirates,
            FlagIcons.Medium.UnitedKingdom,
            FlagIcons.Medium.UnitedStates,
            FlagIcons.Medium.Uruguay,
            FlagIcons.Medium.UsMinorOutlyingIslands,
            FlagIcons.Medium.UsVirginIslands,
            FlagIcons.Medium.Uzbekistan,
            FlagIcons.Medium.Vanuatu,
            FlagIcons.Medium.VaticanCity,
            FlagIcons.Medium.Venezuela,
            FlagIcons.Medium.Vietnam,
            FlagIcons.Medium.Wales,
            FlagIcons.Medium.WallisAndFutuna,
            FlagIcons.Medium.WesternSahara,
            FlagIcons.Medium.Yemen,
            FlagIcons.Medium.Zambia,
            FlagIcons.Medium.Zimbabwe
        )
        return _mediumFlagList!!
    }

@Suppress("ObjectPropertyName")
private var _mediumFlagList: List<ImageVector>? = null
